(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[259],{

/***/ "dJAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/lines/text-line/TextLine.jsx

var __jsx = react_default.a.createElement;



var TextLine_TextLine = function TextLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, __jsx(Text["a" /* Text */], props));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/text/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (TextLine_TextLine);

/***/ })

}]);